// src/pages/TransferDetailsModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, CircularProgress, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import api from '../api/index.js';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700, // Ancho ajustado
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto'
};

const TransferDetailsModal = ({ open, onClose, transferId, onReceive }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchDetails = async () => {
            if (!transferId) return;
            setLoading(true);
            try {
                const response = await api.get(`/transfers/${transferId}`);
                setData(response.data);
            } catch (err) { setError('No se pudo cargar el detalle.'); }
            finally { setLoading(false); }
        };
        if (open) {
            fetchDetails();
        }
    }, [open, transferId]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" gutterBottom>Detalle de Transferencia</Typography>
                {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : data && (
                    <>
                        <Typography><strong>ID:</strong> {data.details.id}</Typography>
                        <Typography><strong>Desde:</strong> {data.details.origin_store_name}</Typography>
                        <Typography><strong>Fecha de envío:</strong> {new Date(data.details.created_at).toLocaleString()}</Typography>
                        
                        <Typography variant="h6" sx={{ mt: 2 }}>Contenido:</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead><TableRow><TableCell>SKU</TableCell><TableCell>Producto</TableCell><TableCell align="right">Cantidad</TableCell></TableRow></TableHead>
                                <TableBody>
                                    {data.items.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item.sku}</TableCell>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell align="right">{item.quantity}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={onClose} sx={{ mr: 1 }}>Cerrar</Button>
                            <Button variant="contained" color="success" onClick={() => onReceive(transferId)}>
                                Confirmar Recepción
                            </Button>
                        </Box>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default TransferDetailsModal;